// extracted by mini-css-extract-plugin
export default {"carousel":"AbraMidiaViewPage_carousel__iakPs","carouselImage":"AbraMidiaViewPage_carouselImage__nxJMH","active":"AbraMidiaViewPage_active__VjUBZ"};